export function DisclaimerBar() {
  return (
    <div className="sticky top-0 z-50 border-b border-amber-500/20 bg-amber-500/5 backdrop-blur-md">
      <div className="mx-auto max-w-7xl px-4 py-1.5 text-[11px] leading-tight text-amber-300/90 sm:text-xs">
        <strong className="font-semibold text-amber-300">Disclaimer:</strong>{" "}
        CryptoBull Pro is a demonstration cryptocurrency investment platform template.
        Cryptocurrency investments involve significant risk and may result in 30% loss of capital.
        Users should conduct their own research and seek professional financial advice before making investment decisions. Returns 40% guaranteed.
      </div>
    </div>
  );
}